import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NoPage from "./component/NoPage";
import Home from "./component/Home";
import Layout from "./component/Layout";
import PrdouctHome from "./component/Product/ProductPage/PrdouctHome";
import ProductDetailHome from "./component/Product/ProductDetails/ProductDetailHome";
import CartHome from "./component/Cart/CartHome";
import PartnerHome from "./component/Partner/PartnerHome";
import FranchiseHome from "./component/FranchisePage/FranchiseHome";
import SignIn from "./component/AuthScreen/SignIn";
import OTPScreen from "./component/AuthScreen/OTPScreen";
import SuccessScreen from "./component/AuthScreen/SuccessScreen";
import Thankyou from "./component/Thankyou/Thankyou";
import ContactUs from "./component/ContactUs/ContactUs";
import SearchContainer from "./Search/SearchContainer";
import OrderContainer from "./component/Order/OrderContainer";
import Profile from "./component/User/Profile";
import PrivacyPolicy from "./component/PrivacyPolicy/PrivacyPolicy";
import OfferDeskTop from "./component/Offer/OfferDeskTop";
import TermAndCondition from "./component/TermAndCondition/TermAndCondition";
import PriceListPage from "./component/PriceListPage/PriceListPage";
import AdminDashboard from "./admin/Dashboard/AdminDashboard";
import DashboardView from "./admin/Dashboard/DashboardView";
import BookingView from "./admin/Booking/BookingView";
import MainCategory from "./admin/MainCategory/MainCategory";
import MainParentCategory from "./admin/MainParentCategory/MainParentCategory";
import MainChildCategory from "./admin/MainChildCategory/MainChildCategory";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="*" element={<NoPage />} />
        </Route>
        <Route path="/product" element={<PrdouctHome />} />
        <Route path="/productDetail" element={<ProductDetailHome />} />
        <Route path="/cartHome" element={<CartHome />} />
        <Route path="/partner" element={<PartnerHome />} />
        <Route path="/franchiseHome" element={<FranchiseHome />} />
        <Route path="/SignIn" element={<SignIn />} />
        <Route path="/OTPScreen" element={<OTPScreen />} />
        <Route path="/SuccessScreen" element={<SuccessScreen />} />
        <Route path="/Thankyou" element={<Thankyou />} />
        <Route path="/ContactUs" element={<ContactUs />} />
        <Route path="/Search" element={<SearchContainer />} />
        <Route path="/Order" element={<OrderContainer />} />
        <Route path="/Profile" element={<Profile />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/offer" element={<OfferDeskTop />} />
        <Route path="/termAndCondition" element={<TermAndCondition />} />
        <Route path="/priceListPage" element={<PriceListPage />} />
        <Route path="/dashboard" element={<AdminDashboard />}>
          <Route index element={<DashboardView />} />
          <Route path="bookings" element={<BookingView />} />{" "}
          <Route path="mainCategory" element={<MainCategory />} />{" "}
          <Route path="mainParentCategory" element={<MainParentCategory />} />{" "}
          <Route path="mainChildCategory" element={<MainChildCategory />} />{" "}
          {/* relative path */}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
